(() => {
  function wire(modalEl) {
    if (!modalEl || modalEl.__confeetZoomWired) return;
    modalEl.__confeetZoomWired = true;

    // Captura o show/hide do próprio componente (sem observer)
    const proto = Object.getPrototypeOf(modalEl);

    // Se o tema ainda não definiu métodos, tenta quando definido
    const originalShow = modalEl.show?.bind(modalEl);
    const originalHide = modalEl.hide?.bind(modalEl);

    if (typeof originalShow === 'function' && !modalEl.__confeetPatchedShow) {
      modalEl.__confeetPatchedShow = true;

      modalEl.show = (opener) => {
        // chama o show original (isso ativa o this.openedBy e showActiveMedia do tema)
        originalShow(opener);

        // modo "single media" usando a classe "active" que o tema já controla
        modalEl.classList.add('confeet-single-media');
        modalEl.classList.remove('is-zoomed');
      };
    }

    if (typeof originalHide === 'function' && !modalEl.__confeetPatchedHide) {
      modalEl.__confeetPatchedHide = true;

      modalEl.hide = () => {
        originalHide();
        modalEl.classList.remove('is-zoomed');
        modalEl.classList.remove('confeet-single-media');
      };
    }

    // 1) Não fechar ao clicar dentro do conteúdo (exceto no botão X)
    modalEl.addEventListener(
      'click',
      (e) => {
        const closeBtn = e.target.closest('.product-media-modal__toggle');
        if (closeBtn) return;

        const inside = e.target.closest('.product-media-modal__content, .product-media-modal__dialog');
        if (!inside) return;

        // impede handlers do ModalDialog que fecham por clique
        e.stopPropagation();
      },
      true
    );

    // 2) Toggle zoom ao clicar na IMAGEM dentro do modal (sem fechar)
    modalEl.addEventListener(
      'click',
      (e) => {
        const img = e.target.closest('.product-media-modal__content img');
        if (!img) return;

        // não aplica zoom em vídeos/iframes etc.
        // (como é img, já garante)
        e.preventDefault();
        e.stopPropagation();

        modalEl.classList.toggle('is-zoomed');
      },
      true
    );

    // 3) ESC remove zoom (o tema já fecha o modal com ESC)
    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (modalEl.classList.contains('is-zoomed')) modalEl.classList.remove('is-zoomed');
    });
  }

  function boot() {
    document.querySelectorAll('product-modal.product-media-modal').forEach(wire);
  }

  // garante que o custom element existe antes de wirear
  if (window.customElements?.whenDefined) {
    customElements.whenDefined('product-modal').then(() => boot());
  } else {
    document.addEventListener('DOMContentLoaded', boot);
  }
})();

